import {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import baseUrl from "../../baseUrl";
import {requester} from "../../services/requester";
import {downloadPdf} from "../../services/downloadPdf";
import {UserFullReportBody} from "./UserFullReport";

// Ъ16 (10.10.2026) — С3/С4 за ЦЯЛА община. Поискано от геодезиста: ползвател +
// община → пълните справки за всяко землище в общината, в което има
// декларация, независимо дали там е чертал. На екрана — една под друга; PDF-ът
// е един общ, землище на страница, всяко със свой подписен блок.
export const UserFullReportMunicipality = ({title, variant = "full", showDeals = true, showCorrection = false}) => {
    const {year, municipality, bullstat} = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const request = requester();

    const query = `municipality=${encodeURIComponent(municipality)}`
        + (variant === "full" ? "" : `&variant=${variant}`);

    useEffect(() => {
        setLoading(true);
        setError('');
        request.get(`${baseUrl()}/reports/s5m/${year}/${bullstat}?${query}`)
            .then(res => {
                setData(res);
                setLoading(false);
            })
            .catch(err => {
                setError(err.message || 'Справката не се зареди.');
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [year, municipality, bullstat, variant]);

    const handlePdf = () => {
        const prefix = variant === "general" ? "S4" : variant === "correction" ? "S8" : "S3";
        downloadPdf(`/reports/s5m/${year}/${bullstat}?${query}&format=pdf`,
            `${prefix}_${bullstat}_${municipality}_${year}.pdf`);
    };

    if (loading) return <div className="mt-3">Зареждане...</div>;
    if (error) return <div className="mt-3 alert alert-warning">{error}</div>;
    if (!data) return <div className="mt-3 alert alert-warning">Няма данни.</div>;

    const c = data.company;
    const землища = data.sections;

    return (
        <div className="mt-3">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
                <div>
                    <h5 style={{color: "var(--app-gold)"}}>{title}</h5>
                    <div className="fw-bold">{c.company_name}, Булстат: {c.bullstat}</div>
                    <div>Община {data.municipality} | Стопанска {data.year} година | {data.date}</div>
                </div>
                {землища.length > 0 && (
                    <button className="btn btn-outline-danger btn-sm" onClick={handlePdf}
                            title="Един файл — всяко землище на отделна страница">
                        PDF ({землища.length} {землища.length === 1 ? 'землище' : 'землища'})
                    </button>
                )}
            </div>

            {землища.length === 0 && (
                <div className="alert alert-warning">
                    Ползвателят няма декларации в община {data.municipality} за стопанска {data.year} година.
                </div>
            )}

            {землища.length > 1 && (
                <div className="text-muted mb-2" style={{fontSize: "0.9rem"}}>
                    Землища с декларация ({землища.length}):{' '}
                    {землища.map((s, i) => (
                        <span key={s.settlement.ekatte}>
                            {i > 0 && ', '}
                            <a href={`#zemlishte-${s.settlement.ekatte}`}
                               onClick={e => {
                                   e.preventDefault();
                                   document.getElementById(`zemlishte-${s.settlement.ekatte}`)
                                       ?.scrollIntoView({behavior: 'smooth', block: 'start'});
                               }}>{s.settlement.settlement}</a>
                        </span>
                    ))}
                </div>
            )}

            {data.skipped > 0 && (
                <div className="alert alert-secondary py-2" style={{fontSize: "0.9rem"}}>
                    {data.skipped === 1 ? '1 землище' : `${data.skipped} землища`} с декларация в общината
                    не {data.skipped === 1 ? 'е показано' : 'са показани'} — нямате достъп до тях.
                </div>
            )}

            {землища.map((s, i) => (
                <div key={s.settlement.ekatte} id={`zemlishte-${s.settlement.ekatte}`}
                     className={i > 0 ? "pt-3 mt-4" : "mt-3"}
                     style={{
                         // горната лента е фиксирана — без това тя закрива заглавието
                         scrollMarginTop: "calc(var(--nav-height, 100px) + 12px)",
                         ...(i > 0 ? {borderTop: "2px solid var(--app-gold)"} : {}),
                     }}>
                    <h6 className="fw-bold mb-2" style={{color: "var(--app-gold)"}}>
                        {s.settlement.settlement}
                    </h6>
                    <UserFullReportBody data={s} showDeals={showDeals} showCorrection={showCorrection}/>
                </div>
            ))}
        </div>
    );
};
